/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useCallback, useState } from 'react'
import { Form, Button, Col, Row, Upload, Spin, Checkbox } from 'antd'
import { UploadOutlined, CheckOutlined } from '@ant-design/icons'
import { CustomForm, Title } from './UserDetailForm.styles'
import FloatLabelInput from '../../FloatLabelInput'
import { useAppSelector } from '../../../store/hooks'
import { REQUEST_STATUS } from '../../../utils/types'
import { fetchSaveUser, isLoading } from '../../../utils'
import { fetchUser } from '../../../store/slices/user/user'
import store from '../../../store'

const formItemLayout = {
    wrapperCol: {
        lg: { span: 24 },
    },
}

const normFile = (e: Record<string, any>) => {
    if (Array.isArray(e)) {
        return e
    }
    return e && e.fileList
}

const UserDetailsForm: React.FC = (): JSX.Element => {
    const user = useAppSelector((state) => state.user!)
    const [requestStatus, setRequestStatus] = useState<REQUEST_STATUS>(
        REQUEST_STATUS.NONE
    )
    const [passwordChanged, setPasswordChanged] = useState<boolean>(false)

    // const [option, setOption] = useState()
    const onSubmit = (formData: unknown): void => {
        setRequestStatus(REQUEST_STATUS.PENDING)
        const { upload, password, ...data } = formData as any
        if (upload && upload.length) {
            data.logo = upload[0].thumbUrl
        }
        if (passwordChanged) {
            data.password = password
        }
        fetchSaveUser(data, user)
            .then(() => {
                setRequestStatus(REQUEST_STATUS.SUCCESS)

                setTimeout(() => {
                    store.dispatch(fetchUser())
                }, 300)
            })
            .catch(() => {
                setRequestStatus(REQUEST_STATUS.FAILED)
            })
    }
    const onSubmitFailed = (): void => {
        setRequestStatus(REQUEST_STATUS.FAILED)
    }
    const onDummyRequest = ({ onSuccess }: any) => {
        setTimeout(() => {
            onSuccess('ok')
        }, 0)
    }
    const handleChangePassword = useCallback((event: any) => {
        setPasswordChanged(event.target.checked)
    }, [])
    const validatePassword = (
        _rule: any,
        value: string,
        callback: (arg0?: string | undefined) => void
    ) => {
        if (value) {
            if (/(?=.*?[A-Z])/.test(value) === false) {
                return callback('At least one upper case!')
            }
            if (/(?=.*?[a-z])/.test(value) === false) {
                return callback('At least one lower case!')
            }
            if (/(?=.*?[0-9])/.test(value) === false) {
                return callback('At least one digit!')
            }
            if (/(?=.*?[#?!@$%^&*-])/.test(value) === false) {
                return callback('At least one special letter!')
            }
            if (/.{8,}/.test(value) === false) {
                return callback('At least eight in length!')
            }
        }
        callback()
    }
    return (
        <Spin spinning={isLoading(requestStatus)}>
            <CustomForm
                onFinish={onSubmit}
                onFinishFailed={onSubmitFailed}
                {...formItemLayout}
            >
                <Row gutter={16}>
                    <Col span={24}>
                        <Title>User Details</Title>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                    >
                        <Form.Item
                            name="firstName"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your first name!',
                                },
                            ]}
                            hasFeedback
                            initialValue={user.firstName}
                            className="form-item-margin"
                        >
                            <FloatLabelInput
                                labelText="First Name"
                                border="2px solid red !important"
                                type="text"
                            />
                        </Form.Item>
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                    >
                        <Form.Item
                            name="lastName"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your last name!',
                                },
                            ]}
                            hasFeedback
                            initialValue={user.lastName}
                            className="form-item-margin"
                        >
                            <FloatLabelInput
                                labelText="Last Name"
                                type="text"
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Form.Item
                            name="email"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your email!',
                                },
                            ]}
                            hasFeedback
                            initialValue={user.email}
                            className="form-item-margin"
                        >
                            <FloatLabelInput labelText="Email" />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                    >
                        <Form.Item
                            name="citizenship"
                            initialValue={user.citizenship}
                        >
                            <FloatLabelInput
                                labelText="Citizenship"
                                type="text"
                            />
                        </Form.Item>
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                    >
                        <Form.Item name="country" initialValue={user.country}>
                            <FloatLabelInput labelText="Country" type="text" />
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Form.Item
                            name="address"
                            rules={[
                                {
                                    required: true,
                                    message:
                                        'Please input your mailing address!',
                                },
                            ]}
                            hasFeedback
                            initialValue={user.address}
                            className="form-item-margin"
                        >
                            <FloatLabelInput
                                labelText="Mailing Address"
                                type="text"
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 10 }}
                    >
                        <Form.Item name="city" initialValue={user.city}>
                            <FloatLabelInput labelText="City" type="text" />
                        </Form.Item>
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 6 }}
                        lg={{ span: 6 }}
                    >
                        <Form.Item name="state" initialValue={user.state}>
                            <FloatLabelInput
                                labelText="State/Province"
                                type="text"
                            />
                        </Form.Item>
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 6 }}
                        lg={{ span: 8 }}
                    >
                        <Form.Item name="zipCode" initialValue={user.zipCode}>
                            <FloatLabelInput labelText="Zip Code" type="text" />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={18}>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 15 }}
                        lg={{ span: 15 }}
                    >
                        <Form.Item name="company" initialValue={user.company}>
                            <FloatLabelInput labelText="Company (Optional)" />
                        </Form.Item>
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 9 }}
                        lg={{ span: 9 }}
                    >
                        <Form.Item
                            name="upload"
                            valuePropName="fileList"
                            getValueFromEvent={normFile}
                        >
                            <Upload
                                customRequest={onDummyRequest}
                                name="logo"
                                listType="picture"
                                maxCount={1}
                            >
                                <Button shape="round" icon={<UploadOutlined />}>
                                    <span style={{ color: '#3c75bf' }}>
                                        Upload profile Picture
                                    </span>
                                </Button>
                            </Upload>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={8}>
                        <Form.Item>
                            <Checkbox onChange={handleChangePassword}>
                                Enable to change password
                            </Checkbox>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                    >
                        {passwordChanged ? (
                            <Form.Item
                                name="password"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input your password!',
                                    },
                                    { validator: validatePassword },
                                ]}
                                hasFeedback
                                className="form-item-margin"
                            >
                                <FloatLabelInput
                                    labelText="New password"
                                    type="password"
                                />
                            </Form.Item>
                        ) : (
                            <FloatLabelInput
                                disabled
                                labelText="New password"
                                type="password"
                            />
                        )}
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                    >
                        {passwordChanged ? (
                            <Form.Item
                                name="confirm"
                                dependencies={['password']}
                                hasFeedback
                                className="form-item-margin"
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            'Please confirm your password!',
                                    },
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            if (
                                                !value ||
                                                getFieldValue('password') ===
                                                    value
                                            ) {
                                                return Promise.resolve()
                                            }
                                            return Promise.reject(
                                                new Error(
                                                    'The two passwords that you entered do not match!'
                                                )
                                            )
                                        },
                                    }),
                                ]}
                            >
                                <FloatLabelInput
                                    labelText="Confirm Password"
                                    type="password"
                                />
                            </Form.Item>
                        ) : (
                            <Form.Item>
                                <FloatLabelInput
                                    disabled
                                    labelText="Confirm Password"
                                    type="password"
                                />
                            </Form.Item>
                        )}
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Form.Item>
                            <div className="Userdetail-btn">
                                <Button
                                    shape="round"
                                    icon={<CheckOutlined />}
                                    htmlType="submit"
                                    style={{ width: '100%' }}
                                >
                                    Submit
                                </Button>
                            </div>
                        </Form.Item>
                    </Col>
                </Row>
            </CustomForm>
        </Spin>
    )
}

export default UserDetailsForm
